export const AUDIO_ASSETS = {
	homeMusic: {
		id: "home-vastness",
		title: "Vastness",
		artist: "Andrew Ev",
		src: "/audio/music/home-vastness.mp3",
	},
	gameplayMusic: [
		{ id: "sports-highlights", title: "Sports Highlights", artist: "Ahjay Stelino", src: "/audio/music/sports-highlights.mp3" },
		{ id: "the-long-road", title: "The Long Road", artist: "Ahjay Stelino", src: "/audio/music/the-long-road.mp3" },
		{ id: "carry-on", title: "Carry On", artist: "Michael Ramir C.", src: "/audio/music/carry-on.mp3" },
		{ id: "ko", title: "K.O.", artist: "Michael Ramir C.", src: "/audio/music/ko.mp3" },
		{ id: "the-duel", title: "The Duel", artist: "Michael Ramir C.", src: "/audio/music/the-duel.mp3" },
		{ id: "proud-of-you", title: "Proud of You", artist: "Michael Ramir C.", src: "/audio/music/proud-of-you.mp3" },
		{ id: "punked-up-fun", title: "Punked Up Fun", artist: "Ahjay Stelino", src: "/audio/music/punked-up-fun.mp3" },
		{ id: "sports-rock", title: "Sports Rock", artist: "Ahjay Stelino", src: "/audio/music/sports-rock.mp3" },
		{ id: "the-root", title: "The Root", artist: "Michael Ramir C.", src: "/audio/music/the-root.mp3" },
		{ id: "caught-on-tape", title: "Caught on Tape", artist: "Michael Ramir C.", src: "/audio/music/caught-on-tape.mp3" },
		{ id: "siren-song", title: "Siren Song", artist: "Michael Ramir C.", src: "/audio/music/siren-song.mp3" },
		{ id: "oh-my-joe", title: "Oh My Joe", artist: "Michael Ramir C.", src: "/audio/music/oh-my-joe.mp3" },
	],
	sfx: {
		ui: "/audio/sfx/sci-fi-click.mp3",
		place: "/audio/sfx/sci-fi-confirmation.mp3",
		upgrade: "/audio/sfx/sci-fi-positive.mp3",
		sell: "/audio/sfx/sci-fi-confirmation.mp3",
		deny: "/audio/sfx/sci-fi-reject.mp3",
		wave: "/audio/sfx/plasma-power-up.mp3",
		waveClear: "/audio/sfx/sci-fi-positive.mp3",
		shot: "/audio/sfx/short-laser-gun-shot.mp3",
		frostShot: "/audio/sfx/short-laser-gun-shot.mp3",
		teslaShot: "/audio/sfx/laser-weapon-shot.mp3",
		hit: "/audio/sfx/short-laser-gun-shot.mp3",
		frostHit: "/audio/sfx/sci-fi-click.mp3",
		teslaHit: "/audio/sfx/laser-weapon-shot.mp3",
		slow: "/audio/sfx/sci-fi-click.mp3",
		armor: "/audio/sfx/apocalyptic-stomp-impact.mp3",
		kill: "/audio/sfx/sci-fi-confirmation.mp3",
		bossKill: "/audio/sfx/laser-cannon-shot.mp3",
		leak: "/audio/sfx/sci-fi-reject.mp3",
		reward: "/audio/sfx/sci-fi-positive.mp3",
	},
};

export const SFX_MIX = {
	ui: 0.36,
	place: 0.52,
	upgrade: 0.58,
	sell: 0.5,
	deny: 0.52,
	wave: 0.62,
	waveClear: 0.72,
	shot: 0.28,
	frostShot: 0.34,
	teslaShot: 0.36,
	hit: 0.18,
	frostHit: 0.24,
	teslaHit: 0.26,
	slow: 0.28,
	armor: 0.24,
	kill: 0.46,
	bossKill: 0.62,
	leak: 0.58,
	reward: 0.68,
};

export const SFX_DURATION_MS = {
	ui: 130,
	place: 260,
	upgrade: 320,
	sell: 240,
	deny: 260,
	shot: 105,
	frostShot: 115,
	teslaShot: 125,
	hit: 80,
	frostHit: 90,
	teslaHit: 100,
	slow: 120,
	armor: 140,
	kill: 280,
	bossKill: 420,
};

export const SFX_RATE = {
	shot: 1.2,
	frostShot: 1.15,
	teslaShot: 1.22,
	hit: 1.25,
	frostHit: 1.2,
	teslaHit: 1.25,
};
